module.exports = "/_next/static/images/image@3x-047a5bf3f6c32fcb25409ccccdd12daa.jpg";